import { Icon, Tooltip } from '@dixa/lib-shared-habla';
import { forwardRef } from 'react';

import styles from './instrumentPanelResizeHandle.module.scss';

export const InstrumentPanelResizeHandle = forwardRef<
  HTMLDivElement,
  Record<string, never>
>(function InstrumentPanelResizeHandle(
  { handleAxis, ...props },
  ref,
): JSX.Element {
  return (
    <div ref={ref} className={styles.root} {...props}>
      <Tooltip content="Drag to resize" side="top" wrap="div">
        <Icon name="angle-right" />
      </Tooltip>
    </div>
  );
});
